$(document).ready(function(){

	function resetActiveMenu(){
		$('.header li').removeClass('hidden active');
	}

	// -- Hamburger --
	$('.hamburger').on('click', function(){
		$('body').toggleClass('mainMenu--open');
		$(this).toggleClass('is-active');
		resetActiveMenu();
	});

	// -- Click outside menu --
	$(document).mouseup(function(e){
    var container = $('.header');
    if (!container.is(e.target) && container.has(e.target).length === 0){
      $('body').removeClass('mainMenu--open');
      $('.hamburger').removeClass('is-active');
      resetActiveMenu();
    }
	});

	// -- Hide brand when footer is in viewport --
	var headerBrandHeight = $('.header__brand').outerHeight(true);
	$(window).on('resize orientationchange', function(){
		headerBrandHeight = $('.header__brand').outerHeight(true);
	});
	$(window).on('scroll resize orientationchange', function(){
		if ($(window).width() > 767) {
		  var top_of_element = $('.footer').offset().top;
	    var bottom_of_element = $('.footer').offset().top + $('.footer').outerHeight();
	    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
	    var top_of_screen = $(window).scrollTop();
	    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
	    	// -- hide brand --
	    	$('.header__brand').css({'transform': 'translateY(-50vh)'});
    		$('.header__navbar').removeClass('md:fixed').addClass('md:relative');
	    } else {
	    	// -- show brand --
    		$('.header__brand').css({'transform': 'translateY(0)'});
	    	$('.header__navbar').removeClass('md:relative').addClass('md:fixed');
	    }
		}
	});


	// -- aria-expended --
	$('.header [aria-expanded]').on('click', function(){
		$(this).attr('aria-expanded', function (i, attr){
	    return attr == 'true' ? 'false' : 'true'
		});
		if ($(this).hasClass('header__burger')) {
			$('.header__mainMenu .level--1 > a').attr('tabindex', function (i, attr){
		    return attr == '-1' ? '0' : '-1'
			});
		} else if ($(this).hasClass('dropdown-toggle')) {
			$(this).next('.pannel').find('.btn--return, .level--2 > a').attr('tabindex', function (i, attr){
		    return attr == '-1' ? '0' : '-1'
			});
		}
	});	

	// -- Main menu animation / dropdown --
	$('.header .dropdown > a:first-of-type').on('click', function(e){
		e.preventDefault();
		$(this).parent('.dropdown').addClass('active');
	});
	$('.header .btn--return').on('click', function(){
		$('.header .dropdown').removeClass('active');
		$(this).attr('tabindex', '-1');
		$(this).next('.dropdown-menu').find('.level--2 > a').attr('tabindex', '-1');
		// $(this).prev('.level--1 > a').focus();
	});

});